module.exports = __webpack_public_path__ + "static/media/Screenshot36.04f91f99.jpg";